/* eslint-disable no-alert */
/* eslint-disable import/no-unresolved */
import Button from "@mui/material/Button";
import { useRef } from "react";
import { useMutation } from "react-query";
import store from "src/redux/store";
import { initiatePayment } from "src/services/Payment";
import CustomLoader from "src/shared/CustomLoader";
import useBilldeskScriptLoader from "src/utils/hooks/useBilldeskScriptLoader";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";

interface Props {
  leadId?: string;
  isButtonEnable: boolean;
  data?: Record<string, any>;
  setIsCancelled?: any;
}

function Payment({ leadId, isButtonEnable = true, data, setIsCancelled }: Props) {
  useBilldeskScriptLoader(); // Load billdesk script required for payment gateway
  const formRef = useRef<HTMLFormElement>(null);
  const { mutate, isLoading } = useMutation(["initiatePayment"], initiatePayment, {
    retry: false,
    onSuccess: (response: any) => {
      if (formRef.current && response?.data?.href) {
        const formElement = formRef.current;

        // Set form action
        formElement.setAttribute("action", response.data.href);

        // Set values for hidden inputs
        const bdOrderIdInput = formElement.querySelector<HTMLInputElement>("#bdorderid");
        const merchantIdInput = formElement.querySelector<HTMLInputElement>("#merchantid");
        const rDataInput = formElement.querySelector<HTMLInputElement>("#rdata");

        if (bdOrderIdInput) bdOrderIdInput.value = response.data.bdorderid || "";
        if (merchantIdInput) merchantIdInput.value = response.data.mercid || "";
        if (rDataInput) rDataInput.value = response.data.rdata || "";

        // Trigger the button click
        const paymentButton = formElement.querySelector<HTMLButtonElement>("#paymentButton");
        if (paymentButton) paymentButton.click();
      }
    },
    onError: () => {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          type: "error",
          message: "Payment initiation failed. Please try again."
        })
      );
    }
  });

  return (
    <div>
      {isLoading && <CustomLoader />}
      <div className="w-90/100 md:w-41/100 rounded-3xl mx-auto h-fit shadow-paymentShadow mt-34.75 pt-13.5 pb-11.25 px-4 md:px-15.5 mb-34.25">
        <div className="font-montserrat text-black text-base font-semibold">
          <div className="flex justify-between">
            <p>Customer Name</p>
            <p>{data?.name || "Bhupinder Jogi"}</p>
          </div>
          <div className="flex justify-between my-8">
            <p>Application Number</p>
            <p>{data?.applicationNo || "APP123221"}</p>
          </div>
          <div className="flex justify-between">
            <p>Loan Account Number</p>
            <p>{data?.loanAcountNo || "1234567890"}</p>
          </div>
        </div>
        <div className="border-1 rounded-lg border-dashed border-quickSilver mb-4 mt-7.25 py-3.25">
          <p className="font-montserrat text-black text-base font-semibold text-center">
            Sum Insured
          </p>
          <p className="font-montserrat font-semibold text-2xl text-hotShot text-center">
            Rs {Number(data?.sumInsured || "123212222").toLocaleString("en-IN")}&nbsp;
          </p>
        </div>
        <div className="border-1 rounded-lg border-dashed border-quickSilver py-3.25">
          <p className="font-montserrat text-black text-base font-semibold text-center">Premium</p>
          <div className="flex items-center justify-center">
            <p className="font-montserrat font-semibold text-2xl text-hotShot">
              Rs {Number(data?.premium || "123212").toLocaleString("en-IN")}&nbsp;
            </p>
            {/* <p className="font-montserrat font-semibold text-sm text-hotShot">per month</p> */}
          </div>
        </div>
        {isButtonEnable && (
          <div className="flex justify-between mt-9.75">
            <Button
              variant="outlined"
              onClick={() => setIsCancelled(true)}
              className="!text-black !uppercase h-12.5 w-472/1000 rounded-lg"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                mutate(leadId!);
              }}
              variant="contained"
              className="!uppercase h-12.5 w-472/1000 rounded-lg"
            >
              Make Payment
            </Button>
          </div>
        )}
      </div>
      <div>
        <form ref={formRef} name="sdklaunch" id="sdklaunch" method="POST">
          <input type="hidden" id="bdorderid" name="bdorderid" />
          <input type="hidden" id="merchantid" name="merchantid" />
          <input type="hidden" id="rdata" name="rdata" />
          <div className="hidden">
            <button id="paymentButton" type="submit">
              Complete your Payment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

Payment.defaultProps = {
  data: {},
  leadId: "",
  setIsCancelled: () => {}
};

export default Payment;
